import { QuizStep } from "../types/quiz";
import { images } from "./images";

export const quizSteps: QuizStep[] = [
  {
    kind: "question",
    id: "q1",
    title: "¿Cuántos años tenés?",
    hint: "Tu cuerpo no procesa igual a las 2 PM que a las 9 PM.",
    input: "age",
    options: [],
  },
  {
    kind: "question",
    id: "q2",
    title: "¿En qué momento sentís más hinchazón abdominal?",
    options: [
      { id: "A", label: "Apenas termino de comer", scores: { lenta: 2 } },
      { id: "B", label: "A la noche, antes de dormir", scores: { nocturna: 2, fermentacion: 1 } },
      { id: "C", label: "A la mañana al despertar", scores: { fermentacion: 1, nocturna: 1 } },
      { id: "D", label: "Todo el día", scores: { fermentacion: 1, motilidad: 1 } },
      { id: "E", label: "Va cambiando según lo que coma", scores: { sensibilidad: 2 } },
    ],
  },
  {
    kind: "question",
    id: "q3",
    title: "Cuando te despertás, ¿cómo suele sentirse tu abdomen?",
    image: images.mirror,
    options: [
      { id: "A", label: "Liviano y normal" },
      { id: "B", label: "Un poco inflamado", scores: { fermentacion: 1 } },
      { id: "C", label: "Duro o tenso", scores: { fermentacion: 2 } },
      { id: "D", label: "Como si hubiese comido pesado la noche anterior", scores: { nocturna: 1, lenta: 1 } },
      { id: "E", label: "Cambia mucho de un día a otro", scores: { sensibilidad: 2 } },
    ],
  },
  {
    kind: "question",
    id: "q4",
    title: "¿Cuál de estas cenas aparece más en tu rutina?",
    hint: "No todo lo sano es ideal para la noche.",
    options: [
      { id: "A", label: "Ensalada fría o verduras crudas", scores: { nocturna: 2, sensibilidad: 1 } },
      { id: "B", label: "Yogur, fruta o algo “liviano”", scores: { nocturna: 2 } },
      { id: "C", label: "Pan integral, tostadas o galletas de arroz", scores: { nocturna: 2, sensibilidad: 1 } },
      { id: "D", label: "Pollo, huevo o pescado con vegetales cocidos" },
      { id: "E", label: "Delivery, picoteo o lo que haya", scores: { nocturna: 2, estres: 1 } },
    ],
  },
  {
    kind: "question",
    id: "q5",
    title: "Tu cena suele ser…",
    options: [
      { id: "A", label: "Fría", scores: { nocturna: 2 } },
      { id: "B", label: "Cruda", scores: { nocturna: 2, fermentacion: 1 } },
      { id: "C", label: "Rápida e improvisada", scores: { nocturna: 1, estres: 1 } },
      { id: "D", label: "Caliente y cocida" },
      { id: "E", label: "Depende del día", scores: { nocturna: 1 } },
    ],
  },
  {
    kind: "value",
    id: "v1",
    eyebrow: "{nombre}, este dato es importante:",
    title: "“Liviano” no siempre significa fácil de digerir.",
    paragraphs: [
      "Una ensalada fría puede parecer liviana en el plato, pero de noche puede exigirle más trabajo al intestino, especialmente si hay digestión lenta, estrés, gases o sensibilidad a ciertos alimentos.",
      "Después de los 35, muchas mujeres notan que lo que antes toleraban bien, ahora les genera más pesadez o distensión.",
    ],
    visual: "digestion",
    cta: "CONTINUAR",
  },
  {
    kind: "question",
    id: "q6",
    title: "Después de cenar, ¿qué suele pasarte?",
    options: [
      { id: "A", label: "Gases o eructos", scores: { fermentacion: 2 } },
      { id: "B", label: "Panza dura", scores: { fermentacion: 2 } },
      { id: "C", label: "Acidez o reflujo", scores: { lenta: 2 } },
      { id: "D", label: "Sueño liviano o despertares", scores: { estres: 2 } },
      { id: "E", label: "Nada especial" },
    ],
  },
  {
    kind: "question",
    id: "q7",
    title: "¿Te pasa que te llenás rápido con poca comida?",
    hint: "Cenar poco no siempre es cenar bien.",
    options: [
      { id: "A", label: "Sí, muy seguido", scores: { lenta: 3 } },
      { id: "B", label: "A veces", scores: { lenta: 1 } },
      { id: "C", label: "Solo cuando estoy estresada", scores: { estres: 2 } },
      { id: "D", label: "No, casi nunca" },
    ],
  },
  {
    kind: "question",
    id: "q8",
    title: "¿Cómo describirías tu ritmo intestinal?",
    options: [
      { id: "A", label: "Normal todos los días" },
      { id: "B", label: "Tiendo a constiparme", scores: { motilidad: 3 } },
      { id: "C", label: "Voy varias veces o con urgencia", scores: { sensibilidad: 2, fermentacion: 1 } },
      { id: "D", label: "Alterno entre constipación y diarrea", scores: { sensibilidad: 2, fermentacion: 1 } },
      { id: "E", label: "No lo observo mucho", scores: { motilidad: 1 } },
    ],
  },
  {
    kind: "question",
    id: "q9",
    title: "¿Cuánta agua tomás realmente durante el día?",
    options: [
      { id: "A", label: "Casi nada", scores: { motilidad: 3 } },
      { id: "B", label: "2 a 4 vasos", scores: { motilidad: 2 } },
      { id: "C", label: "5 a 7 vasos" },
      { id: "D", label: "8 vasos o más" },
      { id: "E", label: "Tomo más café, té u otras bebidas que agua", scores: { motilidad: 2 } },
    ],
  },
  {
    kind: "question",
    id: "q10",
    title: "¿Cómo llegás emocionalmente a la cena?",
    options: [
      { id: "A", label: "Tranquila" },
      { id: "B", label: "Cansada, pero normal", scores: { estres: 1 } },
      { id: "C", label: "Estresada o acelerada", scores: { estres: 2, lenta: 1 } },
      { id: "D", label: "Ansiosa y con ganas de dulce", scores: { estres: 2 } },
      { id: "E", label: "Agotada, como si no pudiera pensar", scores: { estres: 3 } },
    ],
  },
  {
    kind: "value",
    id: "v2",
    eyebrow: "Lo que casi nadie te explica",
    title: "{nombre}, si llegás estresada a la cena, tu digestión puede cambiar por completo.",
    paragraphs: [
      "Cuando comés bajo estrés, tu cuerpo no está en el mejor estado para digerir.",
      "El sistema digestivo necesita calma para producir adecuadamente ácido, enzimas y movimiento intestinal. Si llegás a la cena acelerada, cansada o ansiosa, esa comida puede quedarse “trabajando” más tiempo del necesario.",
      "Por eso muchas mujeres no necesitan otra dieta extrema. Necesitan una cena más amable con su biología nocturna.",
    ],
    testimonial: {
      quote:
        "Yo pensaba que el problema era que comía mucho. Pero me di cuenta de que muchas veces cenaba apurada, fría y con estrés. Cambiar eso me hizo mirar mi digestión de otra manera.",
      author: "Laura M., 42 años",
    },
    visual: "stress",
    cta: "SEGUIR CON MI RESULTADO",
  },
  {
    kind: "question",
    id: "q11",
    title: "¿Te despertás entre las 2 y las 4 de la mañana?",
    options: [
      { id: "A", label: "Casi todas las noches", scores: { estres: 3 } },
      { id: "B", label: "Varias veces por semana", scores: { estres: 2 } },
      { id: "C", label: "A veces", scores: { estres: 1 } },
      { id: "D", label: "Casi nunca" },
      { id: "E", label: "Solo cuando ceno tarde o pesado", scores: { nocturna: 2 } },
    ],
  },
  {
    kind: "question",
    id: "q12",
    title: "Después de cenar, ¿te dan ganas de algo dulce?",
    options: [
      { id: "A", label: "Sí, casi siempre", scores: { estres: 1, nocturna: 1 } },
      { id: "B", label: "A veces", scores: { estres: 1 } },
      { id: "C", label: "Solo si cené muy poco", scores: { nocturna: 2 } },
      { id: "D", label: "No" },
      { id: "E", label: "Me pasa más cuando estoy ansiosa", scores: { estres: 2 } },
    ],
  },
  {
    kind: "question",
    id: "q13",
    title: "¿Alguno de estos alimentos suele caerte pesado?",
    options: [
      { id: "A", label: "Lácteos o yogur", scores: { sensibilidad: 2 } },
      { id: "B", label: "Pan, harinas o trigo", scores: { sensibilidad: 2 } },
      { id: "C", label: "Legumbres", scores: { sensibilidad: 1, fermentacion: 1 } },
      { id: "D", label: "Verduras crudas", scores: { sensibilidad: 1, fermentacion: 1 } },
      { id: "E", label: "No estoy segura" },
    ],
  },
  {
    kind: "question",
    id: "q14",
    title: "¿Qué hacés cuando intentás “cuidarte” de noche?",
    hint: "La cena debería ayudar a tu cuerpo a descansar, no obligarlo a trabajar.",
    options: [
      { id: "A", label: "Como ensalada", scores: { nocturna: 2 } },
      { id: "B", label: "Como yogur o fruta", scores: { nocturna: 2 } },
      { id: "C", label: "Como poco y me aguanto", scores: { nocturna: 1, lenta: 1 } },
      { id: "D", label: "Salteo la cena", scores: { nocturna: 2, estres: 1 } },
      { id: "E", label: "Busco algo caliente y simple" },
    ],
  },
  {
    kind: "question",
    id: "q15",
    title: "¿Cuánto tiempo real tenés para preparar la cena?",
    image: images.dinner,
    options: [
      { id: "A", label: "Menos de 10 minutos", scores: { estres: 1 } },
      { id: "B", label: "10 a 15 minutos" },
      { id: "C", label: "20 a 30 minutos" },
      { id: "D", label: "Más de 30 minutos" },
      { id: "E", label: "No es tiempo, es falta de ideas", scores: { nocturna: 1 } },
    ],
  },
  {
    kind: "value",
    id: "v3",
    eyebrow: "El error más común",
    title: "Muchas mujeres no fracasan porque no quieran cuidarse.",
    paragraphs: [
      "Fracasan porque llegan a las 8 o 9 de la noche cansadas, sin plan y con demasiadas decisiones encima. Entonces terminan eligiendo lo de siempre:",
    ],
    list: ["Ensalada fría", "Yogur", "Tostadas", "Picoteo", "Delivery", "O directamente no cenar"],
    closing: "Pero el cuerpo no necesita castigo. Necesita una cena que pueda procesar mientras descansa.",
    visual: "plan",
    cta: "VER MIS ÚLTIMAS PREGUNTAS",
  },
  {
    kind: "question",
    id: "q16",
    title: "¿Probaste algo para mejorar la hinchazón?",
    options: [
      { id: "A", label: "Probióticos", scores: { fermentacion: 1 } },
      { id: "B", label: "Ayuno intermitente", scores: { lenta: 1 } },
      { id: "C", label: "Dejar harinas o azúcar", scores: { sensibilidad: 1 } },
      { id: "D", label: "Infusiones o suplementos", scores: { fermentacion: 1 } },
      { id: "E", label: "Probé de todo y sigo igual" },
      { id: "F", label: "Todavía no probé nada" },
    ],
  },
  {
    kind: "question",
    id: "q17",
    title: "¿Qué frase describe mejor tu situación?",
    hint: "Después de los 35, la estrategia importa más que la fuerza de voluntad.",
    options: [
      { id: "A", label: "“Como sano, pero igual me inflamo.”", scores: { nocturna: 2 } },
      { id: "B", label: "“Me levanto más hinchada que cuando me acosté.”", scores: { fermentacion: 1, nocturna: 1 } },
      { id: "C", label: "“No sé qué cenar para no sentirme mal.”", scores: { nocturna: 1 } },
      { id: "D", label: "“Mi cuerpo cambió después de los 35.”", scores: { lenta: 1 } },
      { id: "E", label: "“Necesito algo simple porque no tengo tiempo.”", scores: { estres: 1 } },
    ],
  },
  {
    kind: "question",
    id: "q18",
    title: "Si pudieras resolver una sola cosa esta semana, ¿cuál sería?",
    hint: "El problema no es tu cuerpo. Es la señal que le estás dando de noche.",
    options: [
      { id: "A", label: "Despertarme con menos hinchazón" },
      { id: "B", label: "Dormir mejor" },
      { id: "C", label: "Dejar de improvisar la cena" },
      { id: "D", label: "Comer liviano sin pasar hambre" },
      { id: "E", label: "Tener un plan claro de 7 días" },
    ],
  },
];
